// extracted by mini-css-extract-plugin
export default {"container":"styles_container__EF6DU","categoryNameText":"styles_categoryNameText__WuKgS","icon":"styles_icon__4Ei4N"};